var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "84px",
    height: "84px",
    viewBox: "0 0 84 84",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun-close-7352612") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-close-7352612",
    fill: "#FF0000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42,0 C18.84,0 0,18.84 0,42 C0,65.16 18.84,84 42,84 C65.16,84 84,65.16 84,42 C84,18.84 65.16,0 42,0 Z M42,78 C22.148,78 6,61.852 6,42 C6,22.148 22.148,6 42,6 C61.852,6 78,22.148 78,42 C78,61.852 61.852,78 42,78 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.34,27.66 C55.1681,26.4881 53.2697,26.4881 52.1017,27.66 L41.9997,37.762 L31.8977,27.66 C30.7258,26.4881 28.8274,26.4881 27.6594,27.66 C26.4875,28.8319 26.4875,30.7303 27.6594,31.8983 L37.7614,42.0003 L27.6594,52.1023 C26.4875,53.2742 26.4875,55.1726 27.6594,56.3406 C28.24924,56.93044 29.011,57.21951 29.7805,57.21951 C30.55,57.21951 31.3196,56.93045 31.9016,56.3406 L42.0036,46.2386 L52.1056,56.3406 C52.69544,56.93044 53.4572,57.21951 54.2267,57.21951 C54.99623,57.21951 55.7658,56.93045 56.3478,56.3406 C57.5197,55.1687 57.5197,53.2703 56.3478,52.1023 L46.2458,42.0003 L56.3478,31.8983 C57.5197,30.7264 57.5197,28.828 56.3478,27.66 L56.34,27.66 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.481c467a74c86c4d2aa3493818597094.svg";
export { ForwardRef as ReactComponent };